import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const TextDecoration = z.enum(["None", "Underline", "Strikethrough"]);
export const TextDecorationValue = TextDecoration;
export const TextDecorationTokenData = tokenAliasOrValue(TextDecorationValue);
